import Rollbar from 'rollbar';
import ignoreTimeout from './ignore-modules/timeout';
import profileService from '@d-services/profile-service/profile-service';

class RollbarLogger {
  constructor() {
    /* istanbul ignore next */
    if (!process.env.ROLLBAR_CLIENT_TOKEN) {
      return;
    }

    /* istanbul ignore next */
    this.initRollbar();
  }

  /* istanbul ignore next */
  async initRollbar() {
    const slug = await profileService.getSlug();

    this._rollbar = new Rollbar({
      accessToken: process.env.ROLLBAR_CLIENT_TOKEN,
      // TODO: re-enable once Google One Tap issues are sorted
      captureUncaught: false,
      captureUnhandledRejections: false,
      hostWhiteList: [ 'reedsy.com' ],
      payload: {
        environment: process.env.RAILS_ENV,
        person: {
          id: slug,
        },
      },
      checkIgnore: function(isUncaught, args, payload) {
        let shouldIgnore = false;

        const firstArg = args[0];
        shouldIgnore = ignoreTimeout(firstArg);

        return shouldIgnore;
      },
    });
  }

  /* istanbul ignore next */
  error(err) {
    if (!this._rollbar) {
      return;
    }

    this._rollbar.error(err);
  }
}

export default new RollbarLogger();
